export const rustoreOpenTestIds = {
  rustoreOpenModalSubmit: 'rustore_open_modal_submit',
  rustoreOpenModalCloseButton: 'rustore_open_modal_close_button',
  rustoreOpenModalMobileRadioButton: 'rustore_open_mobile_radiobutton',
  rustoreOpenModalTvRadioButton: 'rustore_open_tv_radiobutton',
  rustoreOpenShowModalButton: 'rustore_open_show_button',
};
